<template>
  <base-dialog
    :visible.sync="visible"
    :show-close="true"
    width="740px"
    class="dialog-wrap"
    border-radius="none"
  >
    <template v-slot:header>
      <div class="header-wrap">
        <div class="title">{{ title }}</div>
      </div>
    </template>
    <main>
      <div class="main-wrap">
        <div v-if="!showTable" v-loading="!showTable" class="empty"></div>
        <template v-else>
          <div class="search-wrap">
            <el-input
              v-model="searchText"
              size="small"
              placeholder="搜索下载内容"
              clearable
              @keyup.native.enter="search"
              @clear="search"
            >
              <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
            </el-input>
          </div>
          <base-table
            ref="baseTable"
            table-height="100%"
            :tableColumns="tableColumns"
            :tableData="filterDownLogs"
            :showPagination="false"
            class="file-list-table"
          ></base-table>
        </template>
      </div>
    </main>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog.vue"
import BaseTable from "@/components/BaseComponents/Table/index.vue"
import { getDownloadRecord } from "@/api/userCenter/file"

export default {
  name: "down-logs",
  components: { BaseDialog, BaseTable },
  props: {
    fileId: String
  },
  data() {
    const tableColumns = [
      {
        label: "下载人员",
        value: "downloader.name",
        align: "center"
      },
      {
        label: "下载内容",
        value: "attachmentName",
        align: "center"
      },
      {
        label: "下载时间",
        value: "downloadAt",
        align: "center"
      }
    ]
    return {
      tableColumns,
      showTable: true,
      downLogs: [],
      filterDownLogs: [],
      searchText: "",
      visible: false,
      title: "下载记录"
    }
  },
  methods: {
    open(fileId) {
      getDownloadRecord(fileId).then(res => {
        this.downLogs = res.sort(function(a, b) {
          return Date.parse(b.downloadAt) - Date.parse(a.downloadAt)
        })
        this.filterDownLogs = this.downLogs
      })
      this.searchText = ""
      this.visible = true
    },
    search() {
      this.filterDownLogs = this.downLogs.filter(log =>
        log?.attachmentName.includes(this.searchText)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-wrap {
  main {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .main-wrap {
    flex: 1 1;
    display: flex;
    overflow: hidden;
    flex-direction: column;
  }

  .search-wrap {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;

    .el-input {
      width: 280px;
      margin: 5px 6px 5px 0;
    }

    ::v-deep {
      .el-input-group__append {
        padding: 0 10px;
      }
    }
  }

  .file-list-table,
  .empty {
    width: 100%;
  }

  .base-table {
    flex: 1 1;
    overflow: hidden;
  }

  .operation {
    i {
      cursor: pointer;

      & + i {
        margin-left: 4px;
      }

      &:hover {
        color: $color-main;
      }
    }
  }

  ::v-deep .el-dialog {
    height: 60%;
    color: $color-font-first;

    .el-table__body-wrapper {
      .ps__rail-x {
        z-index: 10;
      }
    }

    .el-dialog__body {
      position: relative;
      padding: 0 !important;
      display: flex;
      flex-direction: column;
      height: 100%;
      width: 100%;
    }
  }
}
</style>
